exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-user-agreement-tsx": () => import("./../../../src/pages/userAgreement.tsx" /* webpackChunkName: "component---src-pages-user-agreement-tsx" */),
  "component---src-templates-using-dsg-tsx": () => import("./../../../src/templates/using-dsg.tsx" /* webpackChunkName: "component---src-templates-using-dsg-tsx" */)
}

